<template>
  <div style="margin:20px">
    <div class="top-fluid text-left">
      <h4 style="text-align: center;">{{this.models.title}}</h4>
      <div style="text-indent:2em;">{{this.models.detailed}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      models: {},
    }
  },
  mounted () {
    //查询用户；
    this.$api.getAPI("data/info/" + this.$route.query.id + "?appid=202108&type_id=13000", {
      //key_id: this.$route.query.id
      // id: 1
    }).then(res => {
      console.log(res);

      var db = res.data.data.models;
      console.log(db);
      this.models = db;
    })
  },
  methods: {}

}
	</script>
	
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/help_clause.vue